const appInfo = {
  title: `Scriptantia Adminisztráció és Példatár v.${process.env.REACT_APP_VERSION}`,
};
export default appInfo;
